import { Icon, message } from 'ant-design-vue';

export const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_3895199_ohj6xw7xyo.js'
})

